import Auth from '@Services/Auth';
import moment from 'moment-timezone';
import { loginReducerKey } from './LoginConstants';

export function login(state) {
  return state.get(loginReducerKey);
}

export function ipAddress(state) {
  return login(state).get('ipAddress');
}

export function isAnonymousUser() {
  return Auth && Auth.isAnonymousUser();
}

export function isGrantAnonymoususer() {
  return Auth?.isGrantAnonymoususer();
}

export function isLoading(state) {
  return login(state).get('isLoading');
}

export function loginFail(state) {
  return login(state).get('loginFail');
}

export function isFormDisabled(state) {
  return login(state).get('isFormDisabled');
}

export function hasRegistration(state) {
  return login(state).get('hasRegistration');
}

export function hasInstitutionLogin(state) {
  return login(state).get('hasInstitutionLogin');
}

export function notifications(state) {
  return login(state).get('notifications');
}

export function occurrenceDate(state) {
  return login(state).get('occurrenceDate');
}

export function timestamp(state) {
  return login(state).get('timestamp');
}

export function data(state) {
  return login(state).get('data');
}

export function loginBlockedTime(state) {
  const savedOccurrenceDate = occurrenceDate(state);
  const savedTimestamp = timestamp(state);
  if (!savedOccurrenceDate || !savedTimestamp) {
    return null;
  }

  return moment.duration(moment.utc(savedTimestamp).diff(moment.utc(savedOccurrenceDate))).asSeconds();
}
